'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = require('../../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _validation = require('../../../utils/validation');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUp = require('./SignUp.scss');

var _SignUp2 = _interopRequireDefault(_SignUp);

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpEmail = function (_Component) {
    (0, _inherits3.default)(SignUpEmail, _Component);

    function SignUpEmail(props, context) {
        (0, _classCallCheck3.default)(this, SignUpEmail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignUpEmail.__proto__ || (0, _getPrototypeOf2.default)(SignUpEmail)).call(this, props, context));

        _this.onValueChange = function (event) {
            var newState = {};
            newState[event.target.id] = event.target.value;
            _this.setState(newState);
        };

        _this.onSignUp = function () {
            var email = _this.state.email.trim();
            var emailValid = (0, _validation.email)(email);
            _this.setState({ emailValid: emailValid });
            if (emailValid) {
                _this.props.setEmail(email);
                _this.props.submitCreateAccount(email);
            }
        };

        _this.handleEnterKeyPress = function (event) {
            if (event.key === 'Enter') {
                _this.onSignUp();
            }
            event.stopPropagation();
        };

        _this.state = {
            email: '',
            emailValid: true
        };
        return _this;
    }

    (0, _createClass3.default)(SignUpEmail, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['error', 'submitted']) || (0, _propsComparer2.default)(this.state, nextState, ['email', 'emailValid']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                error = _props.error,
                submitted = _props.submitted;
            var _state = this.state,
                email = _state.email,
                emailValid = _state.emailValid;


            var errorMessage = '';
            var errorOnPage = !emailValid || error;

            var tosLink = (0, _jsx3.default)(_components.Link, {
                to: '/termsandconditions',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'terms_and_conditions'
            }));
            var privacyLink = (0, _jsx3.default)(_components.Link, {
                to: '/privacy',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'privacy_policy'
            }));

            if (!emailValid) {
                errorMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'enter_a_valid_email_address'
                });
            } else if (error) {
                errorMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'we_experienced_a_server_error'
                }); // we could show the error
            }
            return (0, _jsx3.default)('div', {
                className: _SignUp2.default.body
            }, void 0, (0, _jsx3.default)(_components.Input, {
                autoCapitalize: false,
                autoComplete: false,
                autoCorrect: false,
                autoFocus: true,
                errorMessage: errorMessage,
                id: 'email',
                label: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'email_address'
                }),
                onChange: this.onValueChange,
                onKeyPress: this.handleEnterKeyPress,
                type: 'email',
                valid: !errorOnPage
            }), (0, _jsx3.default)('div', {
                className: _SignUp2.default.links
            }, void 0, (0, _jsx3.default)(_components.Button, {
                className: _SignUp2.default.submit,
                tertiary: true,
                disabled: submitted || !email,
                onClick: this.onSignUp
            }, void 0, !submitted ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'start_now'
            }) : (0, _jsx3.default)(_caterwaulComponents.Throbber, {}))), (0, _jsx3.default)('div', {
                className: _SignUp2.default.modalTerms
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'terms_and_privacy',
                values: { privacyLink: privacyLink, tosLink: tosLink }
            })));
        }
    }]);
    return SignUpEmail;
}(_react.Component);

exports.default = SignUpEmail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SignUpModal/SignUpEmail.js
// module id = Dc2Q
// module chunks = 46